export const TEXT_DECORATION_CLASSES = {
    underline: ['underline'],
    overline: ['overline'],
    'line-through': ['line-through'],
    none: ['no-underline'],
};
